import DialogContent from '@mui/material/DialogContent'
import { Dispatch, SetStateAction } from 'react'
import TagEdit from './TagEdit'
import { AddCircle, RemoveCircle } from '../../components/icons'
import {
  SelectedTags,
  UpdateTag,
  UpdateTagCategory,
} from './TransactionListBulkEdit.types'
import { TagCategory } from '../../types'

type TransactionListBulkEditContentProps = {
  selectedTags: SelectedTags
  setSelectedTags: Dispatch<SetStateAction<SelectedTags>>
  tagCategories: TagCategory[]
  totalTransactionNumber: number
  isDeleting: boolean
  hasTransactionsSelected: boolean
}

const TransactionListBulkEditContent = ({
  selectedTags,
  setSelectedTags,
  tagCategories,
  totalTransactionNumber,
  isDeleting,
  hasTransactionsSelected,
}: TransactionListBulkEditContentProps) => {
  const updateTag: UpdateTag = (tag, index) => {
    setSelectedTags((prev) => {
      prev[index][1] = tag
      return [...prev]
    })
  }

  const updateTagCategory: UpdateTagCategory = (tagCategory, index) => {
    setSelectedTags((prev) => {
      prev[index][0] = tagCategory
      return [...prev]
    })
  }

  return (
    <DialogContent>
      <p>
        This will {isDeleting ? 'delete' : 'update'} the tag categories for{' '}
        {hasTransactionsSelected
          ? 'selected transactions'
          : 'transactions across all pages'}{' '}
        ({totalTransactionNumber} transaction
        {totalTransactionNumber > 1 ? 's' : ''}).
      </p>
      {selectedTags.map((selectedTag, i) => (
        <TagEdit
          key={selectedTag[0]?.id || i}
          selectedTag={selectedTag}
          updateTag={(tag) => updateTag(tag, i)}
          updateTagCategory={(tagCategory) => updateTagCategory(tagCategory, i)}
          tagCategories={tagCategories}
          isDeleting={isDeleting}
        />
      ))}
      <div className="flex">
        <AddCircle
          onClick={() => setSelectedTags((prev) => [...prev, [null, null]])}
        />
        <RemoveCircle
          disabled={selectedTags.length <= 1}
          onClick={() => {
            if (selectedTags.length > 1) {
              setSelectedTags((prev) => prev.slice(0, prev.length - 1))
            }
          }}
        />
      </div>
    </DialogContent>
  )
}

export default TransactionListBulkEditContent
